import React from "react";
import { CardBase } from "./partials/CardBase";
import { CardMeta } from "./partials/CardMeta";
import { CardWrapper } from "./partials/CardWrapper";
export const ProgramCard = (props) => {
    var _a;
    return (React.createElement(CardWrapper, null,
        React.createElement(CardBase, { imageUrl: props.options.imageUrl, title: props.options.title, instructorName: props.options.instructorName, rating: props.options.rating, link: `/program/${props.options.id}`, toggleFavourite: props.toggleFavourite
                ? () => props.toggleFavourite({ programId: props.options.id })
                : null, isLiked: props.isLiked, bookedUsersSummary: props.options.bookedUsersSummary, partnerTitle: props.options.partnerTitle }),
        React.createElement(CardMeta, { duration: props.options.duration, filterByChip: props.filterByChip, language: ((_a = props.options.tags) === null || _a === void 0 ? void 0 : _a.includes("English")) ? "English" : "Swedish" })));
};
//# sourceMappingURL=ProgramCard.js.map